import { InputSelect } from '@lmc/ui-kit'
import useGoalsAccess from 'components/AccessControl/features/useGoalsAccess'
import useGoals from 'screens/Residents/screens/ResidentsGoalsScreen/components/useGoals/useGoals'
import styled from 'styled-components'

type LogsGoalsSelectProps = {
  onChange: (value: unknown) => void
  residentID: string
}

const LogsGoalsSelect = ({ onChange, residentID }: LogsGoalsSelectProps) => {
  const hasGoals = useGoalsAccess()
  const { goals, isLoading } = useGoals(residentID)

  return (
    hasGoals && (
      <Wrapper>
        <InputSelect
          mode="multiple"
          placeholder="Add goals"
          onChange={onChange}
          options={
            goals?.map((goal) => ({
              label: goal?.title || 'N/A',
              value: goal?.id,
            })) || []
          }
          isLoading={isLoading}
        />
      </Wrapper>
    )
  )
}

const Wrapper = styled.div`
  max-width: 400px;
  margin: 0px auto;
  margin-bottom: 15px;
`

export default LogsGoalsSelect
